<template>
    <div class="popup-container" :class="{'open': open}">
        <div class="overlay" @click="$emit('close', $event.target)"></div>
        <div class="popup">
            <div class="content-container">
                <div class="popup-header container">
                    <div class="header-title">
                        <h3>{{title}}</h3>
                    </div>
                    <div class="header-close" @click="$emit('close', $event.target)">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24">
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                                <path d="M0 0h24v24H0z" fill="none"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="content container">
                    <slot name="content"></slot>
                </div>
            </div>
            <div class="bottom">
                <slot name="bottom"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "popFromBottom",
        props: {
            open: Boolean,
            title: String
        }
    }
</script>

<style lang="scss">

    .popup-container {
        width: 100vw;
        position: fixed;
        top: 100%;
        background: transparent;
        z-index: 21;
        transition: all .5s;
        left: 0;
        height: 100vh;

        &.open {
            top: 0;
            min-height: 100vh;
        }
    }

    .bottom {
        padding: 0 1rem 1rem;
    }

    .popup {
        background: var(--surface-color-light);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .header-close {
            div {
                cursor: pointer;
            }
        }

        .popup-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;
            height: 48px;

            h2 {
                margin: 0;
            }
        }
    }

    .content-container {
        padding-bottom: 3rem;
        overflow: scroll;
    }

    .content {
        > *:last-child {
            padding-bottom: 24px;
        }
    }

    @include screen-m {

        .content-container {
            padding-bottom: 0;
        }

        .popup-container {
            top: 0;
            left: 0;
            transition: .3s;
            height: 100vh;
            width: 100vw;
            opacity: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: -1;

            .overlay {
                height: 100%;
                width: 100%;
                position: fixed;
                top: 0;
                left: 0;
                background: rgba(0, 0, 0, .5);
                z-index: -1;
            }


            &.open {
                top: 0;
                opacity: 1;
                z-index: 12;

                .content {
                  z-index: 12;
                }
            }

            .popup {
                padding: 2rem;
                width: 70vw;
                max-width: 800px;
                height: 70vh;
                border-radius: var(--radius-big);
                margin: 0 auto;

                .header-close {
                    align-self: flex-start;
                }

            }

            .content {
                position: relative;
                z-index: -1;
            }
        }


    }
</style>
